/**
 * Actions for the New User app
 */

export const SUBMIT_PASSWORD_REQUEST = 'SUBMIT_PASSWORD_REQUEST';
export const SUBMIT_REQUEST_PASSWORD_RESET = 'SUBMIT_REQUEST_PASSWORD_RESET';
export const SET_NEW_PASSWORD = 'SET_NEW_PASSWORD';
export const SET_PASSWORD_HANDOUT_ERROR = 'SET_PASSWORD_HANDOUT_ERROR';
export const SET_PASSWORD_HANDOUT_THROTTLED = 'SET_PASSWORD_HANDOUT_THROTTLED';
export const RESET_PASSWORD_HANDOUT_ERROR = 'RESET_PASSWORD_HANDOUT_ERROR';
export const FINISH_VIEWING_NEW_PASSWORD = 'FINISH_VIEWING_NEW_PASSWORD';
export const FINISH_VIEWING_USERNAME = 'FINISH_VIEWING_USERNAME';
export const SET_PASSWORD = 'SET_PASSWORD';
export const SET_USERNAME = 'SET_USERNAME';
export const NEW_PASSWORD_CONFIRMED = 'NEW_PASSWORD_CONFIRMED';
export const INFO_BOX_DISMISSED = 'INFO_BOX_DISMISSED';
export const CHECK_PASSWORD_RESET_REQUESTED = 'CHECK_PASSWORD_RESET_REQUESTED';

/**
 * Submit a password request
 * @param firstName
 * @param lastName
 * @param dateOfBirth
 */
export function submitPasswordRequest(firstName, lastName, dateOfBirth) {
    return {
        type: SUBMIT_PASSWORD_REQUEST,
        firstName,
        lastName,
        dateOfBirth,
    };
}

export function submitRequestPasswordReset() {
    return {
        type: SUBMIT_REQUEST_PASSWORD_RESET,
    };
}

/**
 * Called when a new password is received from the Teacher Portal service to
 * set it in the state
 */
export function setNewPassword(password, firstName, lastName, username) {
    return { type: SET_NEW_PASSWORD, password, firstName, lastName, username };
}

/**
 * Called when there is an error requesting a new password to show a validation
 * error message
 */
export function setPasswordHandoutError() {
    return { type: SET_PASSWORD_HANDOUT_ERROR };
}

export function setPasswordHandoutThrottled() {
    return { type: SET_PASSWORD_HANDOUT_THROTTLED };
}

/**
 * Called to clear a validation error in the new password request
 */
export function resetPasswordHandoutError() {
    return { type: RESET_PASSWORD_HANDOUT_ERROR };
}

/**
 * Called when the user finishes viewing their new password to go onto the
 * confirm password alert
 */
export function finishViewingNewPassword() {
    return { type: FINISH_VIEWING_NEW_PASSWORD };
}

/**
 * Called when the user presses "Check your details" on the final stage of the onboarding process
 * @return {{type: string}}
 */
export function newPasswordConfirmed() {
    return { type: NEW_PASSWORD_CONFIRMED };
}

//
// V2
//

/**
 * Called when the user finished viewing their username in order to go on
 * to picking their password
 */
export function finishViewingUsername() {
    return { type: FINISH_VIEWING_USERNAME };
}

/**
 * Called when the user has picked their password
 */
export function setPassword(password) {
    return { type: SET_PASSWORD, password };
}

/**
 * Called when the user dismisses the info box
 */
export function infoBoxDismissed() {
    return { type: INFO_BOX_DISMISSED };
}

/**
 * Called when a new password is received from the Teacher Portal service to
 * set it in the state
 */
export function setUsername(firstName, lastName, dateOfBirth, username) {
    return { type: SET_USERNAME, firstName, lastName, dateOfBirth, username };
}

/**
 * Called in the reset password flow to check if the password has been reset
 * by the teacher
 */
export function checkPasswordResetGranted() {
    return { type: CHECK_PASSWORD_RESET_REQUESTED };
}
